module.exports = __webpack_public_path__ + "images/gavdos/routes/SFK-GVD-SFK.png";